export default __webpack_public_path__ + "static/media/m-icon-gnb-btn-popup-close.8b81ccdf.svg";